var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvelopeSidebar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "192 382 40.167 30",
    style: {
      enableBackground: "new 192 382 40.167 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#127AE3"
    },
    d: "M230.461,383.05h-36.586c-0.481,0-0.872,0.391-0.872,0.872v26.135c0,0.48,0.391,0.872,0.872,0.872 h36.586c0.481,0,0.872-0.392,0.872-0.872v-26.135C231.333,383.441,230.942,383.05,230.461,383.05L230.461,383.05z M229.594,407.079 l-10.793-10.792l-1.233,1.229l11.667,11.668h-34.132l11.664-11.668l-1.229-1.229l-10.792,10.792v-22.285h34.847V407.079z  M229.594,407.079"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#127AE3"
    },
    d: "M227.832,384.794l-15.662,15.662l-15.663-15.662h-1.761v0.701l16.806,16.807 c0.341,0.34,0.89,0.34,1.229,0l16.812-16.807v-0.701H227.832z M227.832,384.794"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeSidebar);
export default __webpack_public_path__ + "static/media/envelope-sidebar.7b17e090a994d30ab3f13ccbda2a022b.svg";
export { ForwardRef as ReactComponent };